import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;

export const standardsContainerCss: CSSObject = {
  paddingInline: 0,
  marginBlock: 0,
};

export const titleContainerCss: CSSObject = {
  width: "100%",
  minHeight: "106px",
  backgroundColor: ui.beige[25],
  padding: "12px 32px",
  marginBottom: "-12px",
};

export const selectedChipsCss: CSSObject = {
  backgroundColor: ui.beige[25],
  padding: "12px 32px",
  position: "sticky",
  top: 0,
  zIndex: 2,
};
